var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"my-2 py-2 px-3",class:{ 'item-filled': _vm.filled }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }